import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { AiOutlineDollarCircle } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const purchaseGiftCardLanguages = {
  pageTitle: "Give the gift of Warriors Basketball",
  mainCardTitle: "Share a Gift Card",
  mainCardDescription:
    "Share the magic of Warriors basketball with a friend or loved one. Upon purchase of the gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift is non-refundable.",
  amountTitle: "Gift Card Amount",
  recipientTitle: "Recipient",
  recipientEnabledDesc:
    "The recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Golden State Warriors games.",
  recipientDisabledDesc:
    "If an intended recipient is not specified, once purchased, you will have to forward the unique code ot the recipient. Upon your recipient receiving their gift, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Golden State Warriors games.",
};

export const redeemGiftCardLanguages = {
  pageTitle: "Give the gift of Warriors Basketball",
  mainCardTitle: "Redeem Gift Card",
  mainCardLoggedInDesc:
    "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
  mainCardLoggedOutDesc:
    "Please input the case sensitive unique code provided to redeem the value of the gift card to the Warriors Account Manager.",
  successDesc: "has been added to to your account!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games or Applicable Pack",
    description: "Select the pack you wish to purchase to choose your games.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      " Click Continue and connect your Golden State Warriors account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Account Manager within 48-72 hours of
        purchasing. Reach out to{" "}
        <Link
          href={"mailto:ticketing@warriors.com"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "underline",
            fontWeight: 500,
            textUnderlineOffset: "4px",
          }}
        >
          ticketing@warriors.com
        </Link>{" "}
        or 888-GSW-HOOP for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Golden State Warriors Flex program work?",
    description:
      "The Golden State Warriors program allows fans to select any seat to select regular season games. Simply log into your Golden State Warriors Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Event tickets are delivered directly within your Golden State Warriors Account Manager.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to seasonshare&apos;s{" "}
      <Link
        href={"https://www.attend.tech/terms-of-use"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={"https://www.attend.tech/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      , as well as the{" "}
      <Link
        href={
          "https://www.nba.com/warriors/tickets/partial-plan-and-group-tickets-terms-and-conditions"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Golden State Warriors Mini Plan Terms and Conditions
      </Link>
      , the{" "}
      <Link
        href={"https://www.nba.com/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Golden State Warriors Privacy Policy
      </Link>
      , and the{" "}
      <Link
        href={"https://chasecenter.com/privacy-policy"}
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Chase Center Privacy Policy
      </Link>
      .
    </>
  );
}
